export default "__VITE_ASSET__5f132ff8__"